import React, { ForwardedRef, forwardRef } from 'react';
import { Title } from 'rizzui';
import cn from '../../utils/classNames';

const widgetCardClasses = {
    base: 'border border-muted bg-gray-0 p-5 dark:bg-gray-50 lg:py-4 lg:px-3',
    rounded: {
        sm: 'rounded-sm',
        DEFAULT: 'rounded-lg',
        lg: 'rounded-xl',
        xl: 'rounded-2xl',
    },
};

type WidgetCardTypes = {
    title: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
    rounded?: keyof typeof widgetCardClasses.rounded;
    headerClassName?: string;
    titleClassName?: string;
    actionClassName?: string;
    descriptionClassName?: string;
    className?: string;
    filters?: React.ReactNode;
    onClick?: () => void;
};

function WidgetCard(
    {
        title,
        action,
        description,
        rounded = 'DEFAULT',
        className,
        headerClassName,
        actionClassName,
        titleClassName,
        descriptionClassName,
        filters,
        onClick,
        children,
    }: React.PropsWithChildren<WidgetCardTypes>,
    ref: ForwardedRef<HTMLDivElement>
) {
    return (
        <div
            onClick={onClick}
            className={cn(
                widgetCardClasses.base,
                widgetCardClasses.rounded[rounded],
                className
            )}
            ref={ref}
        >
            <div className={cn(action && 'flex items-start justify-between', headerClassName)}>
                <div>
                    <div className='flex justify-between items-center gap-2'>
                        <Title as="h3" className={cn('text-base font-semibold sm:text-lg', titleClassName)}>
                            {title}
                        </Title>
                        {filters && <div className="flex items-center gap-2">{filters}</div>}
                    </div>
                    {description && (<div className={descriptionClassName}>{description}</div>)}
                </div>
                {action && <div className={cn('ps-2', actionClassName)}>{action}</div>}
            </div>
            {children}
        </div>
    );
}

export default forwardRef(WidgetCard);
WidgetCard.displayName = 'WidgetCard';